// @flow
import context from 'app/common/lib/context';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import timer from 'app/common/lib/timer';

/**
 * Call UserRegisterTrackActionResource and silently log errors.
 * Don't wait for this resource request to finish.  It's not important
 * enough to potentially block the user.
 *
 * @param {string} action Name of the action to record.
 */
const FLUSH_DELAY = 5000;
let actions = [];
let flushTimeout;

export function flush(sync: boolean) {
  const resource = ResourceFactory.create('UserRegisterTrackActionResource', { actions });
  resource.callUpdate({ showError: false, async: !sync });
  actions = [];
  flushTimeout = null;
}

if (typeof window !== 'undefined' && window.addEventListener) {
  window.addEventListener('beforeunload', () => {
    if (actions.length) {
      flush(true);
    }
  });
}

export default function trackRegisterAction(action: string) {
  const encodedAction =
    (window && window.encodeURIComponent && encodeURIComponent(action)) || action;
  actions.push({
    name: encodedAction,
    stage: context.initialPageContext.stage,
    app_version: context.initialPageContext.appVersion,
  });
  if (!flushTimeout) {
    flushTimeout = timer.setTimeout(flush, FLUSH_DELAY);
  }
}

export function trackRegisterActionWithAuxData(action: string, auxData: any) {
  const encodedAction =
    (window && window.encodeURIComponent && encodeURIComponent(action)) || action;
  actions.push({
    name: encodedAction,
    aux_data: auxData,
    stage: context.initialPageContext.stage,
    app_version: context.initialPageContext.appVersion,
  });
  if (!flushTimeout) {
    flushTimeout = timer.setTimeout(flush, FLUSH_DELAY);
  }
}

function getDeviceAppTypeString() {
  const c = context.instance;
  const appType = c.is_mobile_agent ? 'mobile' : 'desktop';
  return `${appType}.${c.country}.${c.user_agent_platform}.${c.browser_name}`;
}

export function trackRegisterActionWithClientData(action: string) {
  trackRegisterAction(action + '.' + getDeviceAppTypeString());
}
